module.exports = __webpack_public_path__ + "static/media/dungeon.c4174711.svg";